import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyle = createUseStyles(({ type, breakpoints, spacing, brandColors }: CmsWrenchTheme) => {
  return {
    leftContent: {
      justifyContent: 'flex-start',
      [`@media (min-width: ${breakpoints.md}px)`]: {
        justifyContent: 'flex-end',
      },
    },
    pageContent: {
      backgroundColor: brandColors.neutral.smoke,
    },
    pathImage: {
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      objectFit: 'contain',
      height: 'auto',
      maxWidth: '100%',
    },
    card: {
      maxWidth: '470px',
      height: '600px',
    },
    headerText: {
      textWrap: 'balance',
    },
  };
});

export default useStyle;
